import styled from 'styled-components'

export const ArtistsScrollList = styled.div`
  display: grid;
  gap: 4px;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.color.mediumGrey} transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 40px;
    background-color: ${({ theme }) => theme.color.mediumGrey};
  }
`
